module.exports = __webpack_public_path__ + "img/logo.4b9cff06.svg";